global.SMK = "SMK";
global.ETH = "ETH";
global.BTC = "BTC";
global.EUR = "EUR";
global.startmark = "startmark";
global.StartMark = "StartMark";



